import { useState, useEffect } from "react";
import StyleInput from "../../components/Button/Input";
import StyleSelect from "../../components/Button/AutoComplete";
import Switch from "react-switch";
import ImageUserHolder from "./ImageUserHolder";
import CustomerXtra from "./CustomerXtra";
import GeoLocation from "./GeoLocation";
import PostReq from "../../utils/PostReq";
function UserForm(props) {
  const [userTab, setUserTab] = useState(0);
  const [StateList, setStateList] = useState("");
  const [StateCity, setStateCity] = useState("");
  const [ChangeGeo, setChangeGeo] = useState(1);
  const [GroupeList, setGroupeList] = useState("");
  const def = props.def;

  const FetchCity = async (stateId) => {
    const result = await PostReq({
      method: "post",
      url: "/setting/list-city",
      body: { stateId: stateId },
    });
    setStateCity("");
    setTimeout(() => setStateCity(result.data), 200);
  };
  const FetchState = async () => {
    const result = await PostReq({
      method: "post",
      url: "/setting/list-state",
      body: {},
    });
    setStateList("");
    setTimeout(() => setStateList(result.data), 200);
  };

  const FetchGroupe = async () => {
    const result = await PostReq({
      method: "GET",
      url: "/panel/user/group-list",
      body: {},
    });
    setGroupeList("");
    setTimeout(() => setGroupeList(result.data), 200);
  };

  useEffect(() => {
    FetchGroupe();
    FetchState();
  }, []);
  return (
    <>
      {/* <div className="customerTab">
        <small
          className={userTab === 0 ? "active" : ""}
          onClick={() => setUserTab(0)}
        >
          اطلاعات اصلی
        </small>
        <small
          className={userTab === 1 ? "active" : ""}
          onClick={() => setUserTab(1)}
        >
          اطلاعات تکمیلی
        </small>
      </div> */}
      <div className="card-form">
        {userTab ? (
          // <CustomerXtra setData={props.setData} def={def} />
          <></>
        ) : (
          <div className="card-input">
            <StyleInput
              title={"*نام"}
              direction={"rtl"}
              class="userInput"
              defaultValue={def ? def.cName : ""}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  cName: e,
                }))
              }
            />
            <StyleInput
              title={"*نام خانوادگی"}
              direction={"rtl"}
              class="userInput"
              defaultValue={def ? def.sName : ""}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  sName: e,
                }))
              }
            />
            <StyleInput
              title={"*شماره تماس"}
              direction={"rtl"}
              class="userInput"
              defaultValue={def ? def.phone : ""}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  phone: e,
                }))
              }
            />
            {/* <StyleInput
              title={"شماره موبایل"}
              direction={"rtl"}
              class="userInput"
              defaultValue={def ? def.mobile : ""}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  mobile: e,
                }))
              }
            /> */}
            <StyleInput
              title={"کدملی"}
              direction={"rtl"}
              class="userInput"
              defaultValue={def ? def.meliCode : ""}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  meliCode: e,
                }))
              }
            />
            <StyleSelect
              title={"گروهبندی"}
              direction={"rtl"}
              class="userInput"
              defaultValue={def ? { group: def.group } : ""}
              options={GroupeList || []}
              label="group"
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  groupCode: e ? e.groupCode : "",
                  group: e ? e.group : "",
                }))
              }
            />
            <StyleSelect
              title={"جنسیت"}
              direction={"rtl"}
              class="userInput"
              defaultValue={def ? def.prefix : ""}
              options={props.PrefixList || []}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  prefix: e ? e : "",
                }))
              }
            />
            <StyleSelect
              title={"استان"}
              direction={"rtl"}
              class="userInput"
              label="stateName"
              defaultValue={def ? { stateName: def.state } : ""}
              options={StateList || []}
              action={(e) => (
                props.setData((prevState) => ({
                  ...prevState,
                  stateId: e ? e.stateId : "",
                  state: e ? e.stateName : "",
                })),
                FetchCity(e && e.stateId)
              )}
            />
            <StyleSelect
              title={"شهر"}
              direction={"rtl"}
              class="userInput"
              label="cityName"
              disabled={StateCity ? false : true}
              defaultValue={def ? { cityName: def.city } : ""}
              options={StateCity || []}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  cityId: e ? e.cityId : "",
                  city: e ? e.cityName : "",
                }))
              }
            />
            {/* <StyleInput
              title={"کدپستی"}
              direction={"rtl"}
              class="userInput"
              defaultValue={def ? def.postalCode : ""}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  postalCode: e,
                }))
              }
            /> */}

            {/* <StyleInput
              title={"کد نقش"}
              direction={"rtl"}
              class="userInput"
              defaultValue={def ? def.roleId : ""}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  roleId: e,
                }))
              }
            /> */}
            {/* {ChangeGeo && def && def.nif ? (
              <div className="geo-wrapper userInput">
                <StyleInput
                  title={"موقعیت مکانی"}
                  direction={"rtl"}
                  defaultValue={def && def.nif}
                  action={(e) =>
                    props.setData((prevState) => ({
                      ...prevState,
                      nif: e,
                    }))
                  }
                />
                <div className="geo">
                  <i
                    class="fa fa-pencil-square-o"
                    aria-hidden="true"
                    onClick={() => setChangeGeo(0)}
                  ></i>
                </div>
              </div>
            ) : (
              <div class="userInput geo-input">
                <GeoLocation update={props.setData} />
                <span>موقعیت مکانی</span>
              </div>
            )} */}

            {/* <div className="placeHolder">
                  {geo?<GeoLocation update={props.setData}/>:
                  <i className="fa fa-eye" onClick={()=>setGeo(1)}/>}
                </div> */}
            <StyleInput
              title={"آدرس"}
              direction={"rtl"}
              class="userInput fullRow"
              defaultValue={def ? def.Address : ""}
              action={(e) =>
                props.setData((prevState) => ({
                  ...prevState,
                  Address: e,
                }))
              }
            />
            {/*<div className="official">
                    <label htmlFor="active">رسمی</label>
                    <Switch onChange={(e)=>props.setData(data => ({
                            ...data,
                            ...{official:e?"true":"false"}
                            }))} checked={props.data&&
                            props.data.active==="true"?true:false} />
                            </div>*/}
            <div className="imageUser">
              <ImageUserHolder
                imageUrl={
                  props.imageUrl ? props.imageUrl : def ? def.imageUrl1 : ""
                }
                setImageUrl={props.setImageUrl}
                imageUrl2={
                  props.imageUrl2 ? props.imageUrl2 : def ? def.imageUrl2 : ""
                }
                setImageUrl2={props.setImageUrl2}
                kasbUrl={props.kasbUrl ? props.kasbUrl : def ? def.kasbUrl : ""}
                setKasbUrl={props.setKasbUrl}
                init={0}
                def={def}
                titles={["تصویر کارت ملی*"]}
              />
            </div>
            {/* <div className="imageUser">
              <ImageUserHolder
                imageUrl={
                  props.shopUrl1 ? props.shopUrl1 : def ? def.shopUrl1 : ""
                }
                setImageUrl={props.setShopUrl1}
                imageUrl2={
                  props.shopUrl2 ? props.shopUrl2 : def ? def.shopUrl2 : ""
                }
                setImageUrl2={props.setShopUrl2}
                kasbUrl={
                  props.shopUrl3 ? props.shopUrl3 : def ? def.shopUrl3 : ""
                }
                setKasbUrl={props.setShopUrl3}
                init={10}
                def={def}
                titles={[
                  "تصویر محل کسب 2",
                  "تصویر محل کسب 3",
                  "تصویر محل کسب 1*",
                ]}
              />
            </div> */}
          </div>
        )}
      </div>
    </>
  );
}
export default UserForm;
